/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type BucketId = "DataInputChange" | "FailureToAppear" | "NoAttendanceData" | "NoAttendanceIntegrationData" | "NoFutureCourtDate" | "NoFutureEvents" | "OneYearAnniversary" | "RecentDataInput" | "StaleDataInput" | "SupervisionDateReview" | "UpcomingUnreviewedCourtDate" | "%future added value";
export type DataInputField = "aa_meeting" | "address" | "employment" | "law_enforcement_contact" | "%future added value";
export type DataInputType = "confirmation" | "verification" | "%future added value";
export type ReviewItemsTableGqlQueryVariables = {
    readonly review_type: BucketId;
    readonly case_manager_id?: string | null;
};
export type ReviewItemsTableGqlQueryResponse = {
    readonly application: ({
        readonly risk_levels: ReadonlyArray<({
            readonly key: string;
            readonly value: string | null;
        }) | null> | null;
        readonly compliance_options: ReadonlyArray<({
            readonly key: string;
            readonly value: string | null;
        }) | null> | null;
    }) | null;
    readonly review_items: ({
        readonly review_item: ReadonlyArray<({
            readonly id: string;
            readonly expires_at: string | null;
            readonly expired: boolean;
            readonly created_at: string | null;
            readonly reviewed: boolean;
            readonly reviewed_at: string | null;
            readonly reviewed_by_case_manager: ({
                readonly id: string;
                readonly name: {
                    readonly first: string;
                    readonly last: string | null;
                };
            }) | null;
            readonly document_id: string | null;
            readonly event: ({
                readonly id: string | null;
                readonly date: string | null;
                readonly created_at: string | null;
                readonly attended: string | null;
                readonly participant_id: string | null;
                readonly activity: {
                    readonly title: {
                        readonly en: string | null;
                        readonly es: string | null;
                    };
                };
                readonly obligation: ({
                    readonly id: string | null;
                    readonly title: ({
                        readonly en: string | null;
                        readonly es: string | null;
                    }) | null;
                }) | null;
                readonly input_field_name: DataInputField | null;
                readonly input_response_text: string | null;
            }) | null;
            readonly type: string;
            readonly obligation: ({
                readonly id: string | null;
                readonly title: ({
                    readonly en: string | null;
                    readonly es: string | null;
                }) | null;
                readonly service_provider: ({
                    readonly id: string | null;
                    readonly title: string | null;
                }) | null;
                readonly activity: ({
                    readonly data_input_field: DataInputField | null;
                    readonly data_input_type: DataInputType | null;
                }) | null;
                readonly start: string | null;
                readonly is_writable: boolean | null;
                readonly next_input_event: ({
                    readonly date: string | null;
                }) | null;
                readonly last_input_event: ({
                    readonly date: string | null;
                }) | null;
            }) | null;
            readonly participant: ({
                readonly id: string;
                readonly name: {
                    readonly first: string;
                    readonly last: string | null;
                };
                readonly preferred_name: string | null;
                readonly risk_level: string | null;
                readonly status: string | null;
                readonly compliance: string | null;
                readonly case_manager: ({
                    readonly id: string;
                    readonly name: {
                        readonly first: string;
                        readonly last: string | null;
                    };
                }) | null;
                readonly supervision_begin_date: string | null;
                readonly supervision_end_date: string | null;
                readonly tasks: ReadonlyArray<({
                    readonly id: string;
                    readonly label: string | null;
                    readonly completed_at: string | null;
                }) | null> | null;
                readonly program_title: string | null;
                readonly address: ({
                    readonly value: string | null;
                    readonly last_value: string | null;
                }) | null;
                readonly employment: ({
                    readonly value: string | null;
                    readonly last_value: string | null;
                }) | null;
                readonly law_enforcement_contact: ({
                    readonly value: string | null;
                    readonly last_value: string | null;
                }) | null;
                readonly aa_meeting: ({
                    readonly value: string | null;
                    readonly last_value: string | null;
                }) | null;
                readonly sms_enabled: boolean | null;
                readonly sms_consent: boolean | null;
                readonly phone: ({
                    readonly mobile: string | null;
                }) | null;
                readonly current_device: ({
                    readonly device_id: string | null;
                }) | null;
                readonly case_number: string | null;
                readonly case_numbers: ReadonlyArray<string | null> | null;
                readonly sent_message_unread_count: number | null;
            }) | null;
        }) | null> | null;
    }) | null;
};
export type ReviewItemsTableGqlQuery = {
    readonly response: ReviewItemsTableGqlQueryResponse;
    readonly variables: ReviewItemsTableGqlQueryVariables;
};



/*
query ReviewItemsTableGqlQuery(
  $review_type: BucketId!
  $case_manager_id: String
) {
  application {
    risk_levels {
      key
      value
    }
    compliance_options {
      key
      value
    }
    id
  }
  review_items(case_manager_id: $case_manager_id, review_type: $review_type) {
    review_item {
      id
      expires_at
      expired
      created_at
      reviewed
      reviewed_at
      reviewed_by_case_manager {
        id
        name {
          first
          last
        }
      }
      document_id
      event {
        id
        date
        created_at
        attended
        participant_id
        activity {
          title {
            en
            es
          }
          id
        }
        obligation {
          id
          title {
            en
            es
          }
        }
        input_field_name
        input_response_text
      }
      type
      obligation {
        id
        title {
          en
          es
        }
        service_provider {
          id
          title
        }
        activity {
          data_input_field
          data_input_type
          id
        }
        start
        is_writable
        next_input_event {
          date
          id
        }
        last_input_event {
          date
          id
        }
      }
      participant {
        id
        name {
          first
          last
        }
        preferred_name
        risk_level
        status
        compliance
        case_manager {
          id
          name {
            first
            last
          }
        }
        supervision_begin_date
        supervision_end_date
        tasks {
          id
          label
          completed_at
        }
        program_title
        address {
          value
          last_value
        }
        employment {
          value
          last_value
        }
        law_enforcement_contact {
          value
          last_value
        }
        aa_meeting {
          value
          last_value
        }
        sms_enabled
        sms_consent
        phone {
          mobile
        }
        current_device {
          device_id
        }
        case_number
        case_numbers
        sent_message_unread_count(unread_for: "all")
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "review_type",
            "type": "BucketId!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "case_manager_id",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "key",
            "args": null,
            "storageKey": null
        } as any),
        (v1 /*: any*/)
    ], v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "risk_levels",
        "storageKey": null,
        "args": null,
        "concreteType": "KeyedString",
        "plural": true,
        "selections": (v2 /*: any*/)
    } as any), v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "compliance_options",
        "storageKey": null,
        "args": null,
        "concreteType": "KeyedString",
        "plural": true,
        "selections": (v2 /*: any*/)
    } as any), v5 = [
        ({
            "kind": "Variable",
            "name": "case_manager_id",
            "variableName": "case_manager_id"
        } as any),
        ({
            "kind": "Variable",
            "name": "review_type",
            "variableName": "review_type"
        } as any)
    ], v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expires_at",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expired",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "created_at",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "reviewed",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "reviewed_at",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "name",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonName",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "first",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "last",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v13 = [
        (v6 /*: any*/),
        (v12 /*: any*/)
    ], v14 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "reviewed_by_case_manager",
        "storageKey": null,
        "args": null,
        "concreteType": "CaseManager",
        "plural": false,
        "selections": (v13 /*: any*/)
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "document_id",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "date",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "attended",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "participant_id",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "title",
        "storageKey": null,
        "args": null,
        "concreteType": "i18nText",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "en",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "es",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "obligation",
        "storageKey": null,
        "args": null,
        "concreteType": "Obligation",
        "plural": false,
        "selections": [
            (v6 /*: any*/),
            (v19 /*: any*/)
        ]
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "input_field_name",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "input_response_text",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "service_provider",
        "storageKey": null,
        "args": null,
        "concreteType": "ServiceProvider",
        "plural": false,
        "selections": [
            (v6 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "data_input_field",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "data_input_type",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "start",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is_writable",
        "args": null,
        "storageKey": null
    } as any), v29 = [
        (v16 /*: any*/)
    ], v30 = [
        (v1 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "last_value",
            "args": null,
            "storageKey": null
        } as any)
    ], v31 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "participant",
        "storageKey": null,
        "args": null,
        "concreteType": "Participant",
        "plural": false,
        "selections": [
            (v6 /*: any*/),
            (v12 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "preferred_name",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "risk_level",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "compliance",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "case_manager",
                "storageKey": null,
                "args": null,
                "concreteType": "CaseManager",
                "plural": false,
                "selections": (v13 /*: any*/)
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "supervision_begin_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "supervision_end_date",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "tasks",
                "storageKey": null,
                "args": null,
                "concreteType": "ParticipantTask",
                "plural": true,
                "selections": [
                    (v6 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "label",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "completed_at",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "program_title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "address",
                "storageKey": null,
                "args": null,
                "concreteType": "VerifiedAddress",
                "plural": false,
                "selections": (v30 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "employment",
                "storageKey": null,
                "args": null,
                "concreteType": "VerifiedEmployment",
                "plural": false,
                "selections": (v30 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "law_enforcement_contact",
                "storageKey": null,
                "args": null,
                "concreteType": "VerifiedLawEnforcementContact",
                "plural": false,
                "selections": (v30 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "aa_meeting",
                "storageKey": null,
                "args": null,
                "concreteType": "VerifiedAaMeeting",
                "plural": false,
                "selections": (v30 /*: any*/)
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "sms_enabled",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "sms_consent",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "phone",
                "storageKey": null,
                "args": null,
                "concreteType": "PersonPhone",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "mobile",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "current_device",
                "storageKey": null,
                "args": null,
                "concreteType": "ParticipantMobileDevice",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "device_id",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "case_number",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "case_numbers",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "sent_message_unread_count",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "unread_for",
                        "value": "all"
                    }
                ],
                "storageKey": "sent_message_unread_count(unread_for:\"all\")"
            }
        ]
    } as any), v32 = [
        (v16 /*: any*/),
        (v6 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ReviewItemsTableGqlQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "application",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Application",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/)
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "review_items",
                    "storageKey": null,
                    "args": (v5 /*: any*/),
                    "concreteType": "Pagination",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "review_item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ReviewItem",
                            "plural": true,
                            "selections": [
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "event",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v16 /*: any*/),
                                        (v9 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "activity",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Activity",
                                            "plural": false,
                                            "selections": [
                                                (v19 /*: any*/)
                                            ]
                                        },
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/)
                                    ]
                                },
                                (v23 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "obligation",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Obligation",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v19 /*: any*/),
                                        (v24 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "activity",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Activity",
                                            "plural": false,
                                            "selections": [
                                                (v25 /*: any*/),
                                                (v26 /*: any*/)
                                            ]
                                        },
                                        (v27 /*: any*/),
                                        (v28 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "next_input_event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": (v29 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "last_input_event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": (v29 /*: any*/)
                                        }
                                    ]
                                },
                                (v31 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ReviewItemsTableGqlQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "application",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Application",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v6 /*: any*/)
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "review_items",
                    "storageKey": null,
                    "args": (v5 /*: any*/),
                    "concreteType": "Pagination",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "review_item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ReviewItem",
                            "plural": true,
                            "selections": [
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "event",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v16 /*: any*/),
                                        (v9 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "activity",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Activity",
                                            "plural": false,
                                            "selections": [
                                                (v19 /*: any*/),
                                                (v6 /*: any*/)
                                            ]
                                        },
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/)
                                    ]
                                },
                                (v23 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "obligation",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Obligation",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v19 /*: any*/),
                                        (v24 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "activity",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Activity",
                                            "plural": false,
                                            "selections": [
                                                (v25 /*: any*/),
                                                (v26 /*: any*/),
                                                (v6 /*: any*/)
                                            ]
                                        },
                                        (v27 /*: any*/),
                                        (v28 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "next_input_event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": (v32 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "last_input_event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": (v32 /*: any*/)
                                        }
                                    ]
                                },
                                (v31 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ReviewItemsTableGqlQuery",
            "id": null,
            "text": "query ReviewItemsTableGqlQuery(\n  $review_type: BucketId!\n  $case_manager_id: String\n) {\n  application {\n    risk_levels {\n      key\n      value\n    }\n    compliance_options {\n      key\n      value\n    }\n    id\n  }\n  review_items(case_manager_id: $case_manager_id, review_type: $review_type) {\n    review_item {\n      id\n      expires_at\n      expired\n      created_at\n      reviewed\n      reviewed_at\n      reviewed_by_case_manager {\n        id\n        name {\n          first\n          last\n        }\n      }\n      document_id\n      event {\n        id\n        date\n        created_at\n        attended\n        participant_id\n        activity {\n          title {\n            en\n            es\n          }\n          id\n        }\n        obligation {\n          id\n          title {\n            en\n            es\n          }\n        }\n        input_field_name\n        input_response_text\n      }\n      type\n      obligation {\n        id\n        title {\n          en\n          es\n        }\n        service_provider {\n          id\n          title\n        }\n        activity {\n          data_input_field\n          data_input_type\n          id\n        }\n        start\n        is_writable\n        next_input_event {\n          date\n          id\n        }\n        last_input_event {\n          date\n          id\n        }\n      }\n      participant {\n        id\n        name {\n          first\n          last\n        }\n        preferred_name\n        risk_level\n        status\n        compliance\n        case_manager {\n          id\n          name {\n            first\n            last\n          }\n        }\n        supervision_begin_date\n        supervision_end_date\n        tasks {\n          id\n          label\n          completed_at\n        }\n        program_title\n        address {\n          value\n          last_value\n        }\n        employment {\n          value\n          last_value\n        }\n        law_enforcement_contact {\n          value\n          last_value\n        }\n        aa_meeting {\n          value\n          last_value\n        }\n        sms_enabled\n        sms_consent\n        phone {\n          mobile\n        }\n        current_device {\n          device_id\n        }\n        case_number\n        case_numbers\n        sent_message_unread_count(unread_for: \"all\")\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '7c303b9e8c03b93081b5faec7c4dec06';
export default node;
